export function strlSetCookie(cname, cvalue, exdays) {
	// eslint-disable-line
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function strlGetCookie(cname) {
	// eslint-disable-line
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function mediaQuery(screen) {
	let styles = getComputedStyle(document.documentElement);
	let media = '';

	if ('sm' === screen) {
		media = `(max-width:${styles.getPropertyValue('--breakpoint-md')})`;
	}

	if ('md' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-md')}) and (max-width:${styles.getPropertyValue('--breakpoint-lg')})`;
	}

	if ('md-up' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-md')})`;
	}

	if ('lg' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-lg')} and (max-width:${styles.getPropertyValue('--breakpoint-xl')})`;
	}

	if ('lg-up' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-lg')})`;
	}

	if ('xl' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-xl')})`;
	}

	return media ? window.matchMedia(media).matches : false;
}

export function slideUp(target, duration = 300) {
	if (target.style.display === 'none') {
		return;
	}
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		//alert("!");
	}, duration);
}

export function slideDown(target, duration = 300) {
	if (target.style.display === 'block') {
		return;
	}
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;

	if (display === 'none') display = 'block';

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}

export function slideToggle(target, duration = 300) {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
}

export function animateDetails() {
	const details = document.querySelectorAll('details');
	details.forEach((detail) => {
		const content = detail.querySelector('.details-content');
		if (content) {
			detail.classList.add('cursor-pointer');
			detail.setAttribute('open', '');
			content.classList.add('hidden');
			detail.addEventListener('click', function (e) {
				e.preventDefault();
				slideToggle(content);
				detail.classList.toggle('open');
			});
		}
	});
}
